import { Component, OnInit } from '@angular/core';
import { EntityDirectoryService } from 'src/app/v2/views/entity-directory/entity-directory.service';

@Component({
  selector: 'entity-repository',
  templateUrl: './repository.component.html',
  styleUrls: ['./repository.component.scss']
})
export class EntityRepositoryComponent implements OnInit {

  constructor(private service: EntityDirectoryService) {
    
  }

  ngOnInit() {
  }

  /**
   * Gets the reports from the service, also passing them through the active
   * filter.
   */
  getReports() {
    return this.service.filteredEntityReports;
  }

  downloadReport({ report }) {
    console.log('Download requests', report);
    this.service.downloadReport(report);
  }
}
